import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule , ReactiveFormsModule  } from '@angular/forms'; 
import { SelectDropDownModule } from 'ngx-select-dropdown';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';

//aggrid
import { AgGridModule } from 'ag-grid-angular';
//import { LicenseManager } from "ag-grid-enterprise/main";

//bootstrap components
import { PopoverModule } from 'ngx-bootstrap/popover';
import { CollapseModule } from 'ngx-bootstrap';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';


//translate
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { HeaderComponent } from './header/header.component';
import { LandingComponent } from './landing/landing.component';
import { UserComponent } from './admin/user/user.component';
import { PatientReportsComponent } from './patient-reports/patient-reports.component';
import { AlertComponent } from './util/alert/alert.component';
import { UserCustomCellComponent } from './admin/user/user-custom-cell/user-custom-cell.component';
import { ClinicCustomCellComponent } from './admin/clinic/clinic-custom-cell/clinic-custom-cell.component';
import { EditProfileComponent } from './account/edit-profile/edit-profile.component';
import { ChangePasswordComponent } from './account/change-password/change-password.component';
import { ClinicComponent } from './admin/clinic/clinic.component';
import { MachineComponent } from './admin/machine/machine.component';
import { MachineCustomCellComponent } from './admin/machine/machine-custom-cell/machine-custom-cell.component';
import { PatientComponent } from './admin/patient/patient.component';
import { PatientCustomCellComponent } from './admin/patient/patient-custom-cell/patient-custom-cell.component';
import { PatientReportsCustomCellComponent } from './patient-reports/patient-reports-custom-cell/patient-reports-custom-cell.component';
import { TBBO2TherapyReportComponent } from './tbbo2-therapy-report/tbbo2-therapy-report.component';
import { TBBO2TherapyReportCustomCellComponent } from './tbbo2-therapy-report/tbbo2-therapy-report-custom-cell/tbbo2-therapy-report-custom-cell.component';
import { TBBO2RecoveryTimeReportComponent } from './tbbo2-recovery-time-report/tbbo2-recovery-time-report.component';
import { TBBO2RecoveryTimeReportCustomCellComponent } from './tbbo2-recovery-time-report/tbbo2-recovery-time-report-custom-cell/tbbo2-recovery-time-report-custom-cell.component';
import { ImportDataComponent } from './admin/import-data/import-data.component';
import { from } from 'rxjs';
import { PasscodeComponent } from './admin/passcode/passcode.component';
import { ServiceCodesScanComponent } from './device/service-codes-scan/service-codes-scan.component';
import { ServiceCodesScanCustomCellComponent } from './device/service-codes-scan/service-codes-scan-custom-cell/service-codes-scan-custom-cell.component';
import { PrivacyComponent } from './privacy/privacy/privacy.component';
import { DeleteAccountComponent } from './account/delete-account/delete-account.component';
import { ManageDeleteRequestsComponent } from './admin/manage-delete-requests/manage-delete-requests.component';

//LicenseManager.setLicenseKey("");
export function HttpLoaderFactory(HttpClient: HttpClient) {
	return new TranslateHttpLoader(HttpClient, "i18n/", ".json");
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HeaderComponent,
    UserComponent,
    LandingComponent,
    PatientReportsComponent,
    AlertComponent,
    UserCustomCellComponent,
    ClinicCustomCellComponent,
    EditProfileComponent,
    ChangePasswordComponent,
    ClinicComponent,
    MachineComponent,
    MachineCustomCellComponent,
    PatientComponent,
    PatientCustomCellComponent,
    PatientReportsCustomCellComponent,
    TBBO2TherapyReportCustomCellComponent,
    TBBO2TherapyReportComponent,
    TBBO2RecoveryTimeReportComponent,
    TBBO2RecoveryTimeReportCustomCellComponent,
    ImportDataComponent,
    PasscodeComponent,
    ServiceCodesScanComponent,
    ServiceCodesScanCustomCellComponent,
    PrivacyComponent,
    DeleteAccountComponent,
    ManageDeleteRequestsComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    SelectDropDownModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient]
			}
    }),
    PopoverModule.forRoot(),
    CollapseModule.forRoot(),
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    AgGridModule.withComponents([])
  ],
  providers: [],
  entryComponents: [UserCustomCellComponent, ClinicCustomCellComponent, MachineCustomCellComponent, 
    PatientCustomCellComponent, PatientReportsCustomCellComponent, 
    TBBO2TherapyReportCustomCellComponent, TBBO2RecoveryTimeReportCustomCellComponent,ServiceCodesScanCustomCellComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
